import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {onyx, onyxLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  inputContainer: {
    flexDirection: 'row',
    alignSelf: 'center',
    marginHorizontal: indent,
    marginTop: indent * 0.5,
  },
  formField: {
    flex: 1,
    borderRadius: 5,
    borderWidth: 1,
    borderColor: onyxLight,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: indent * 0.5,
    paddingVertical: indent * 0.5,
  },
  focusedFormField: {
    borderWidth: 1.5,
  },
  textInput: {
    flex: 1,
    fontSize: 15,
  },
  btnClear: {
    position: 'absolute',
    right: 10,
    top: '50%',
    transform: [{translateY: -10}],
    height: 20,
    width: 20,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
  },
  clearIcon: {
    fontSize: 18,
    color: onyx,
  },
  btnCancel: {
    paddingVertical: 20,
  },
  container: {
    width: '100%',
    paddingHorizontal: indent,
    marginTop: indent * 0.5,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  formFieldWrapper: {
    flex: 1,
    position: 'relative',
  },
  label: {
    marginTop: 4,
    color: '#000',
  },
});
